import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);  // initial state: false
  loading$ = this.loadingSubject.asObservable();

  // Method to set loading state
  setLoading(loading: boolean) {
    this.loadingSubject.next(loading);
  }
}